import React from "react";

export default function TableRow(props) {
  return <tbody className="c-table__body">{props.children}</tbody>;
}
